<template>
  <div class="inline-block time-clock">
    <svg-icon
      iconClass="time"
      className="time-clock-icon"
      class="w-20"
    ></svg-icon>
    <span>{{ time }}</span>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  data() {
    return {
      time: moment().format('DD-MMM-YYYY hh:mm A'),
      timer: ''
    }
  },
  mounted() {
    this.timer = setInterval(this.updateTime, 1000)
  },
  methods: {
    updateTime() {
      this.time = moment().format('DD-MMM-YYYY hh:mm A')
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  }
}
</script>

<style></style>
